import { bookingResponse } from './bookingResponse';

export const ProviderGoogleAds = {
  bookingResponse,
};
